<script>
import {h, resolveComponent} from 'vue';
import _ from 'lodash';
import ECharts from 'vue-echarts';
import 'echarts/lib/chart/pie';
import 'echarts/lib/component/tooltip';
import 'echarts/lib/component/legendScroll';

import {CHART} from '@/components/constants/chart';
import widgetWrapper from '@/components/widgets/common/widgetWrapper';
import i18nMixin from '@/mixins/i18n.mixin.js';

export default {
  name: 'widgetChartPie',
  emits: ['more'],
  mixins: [i18nMixin],
  components: {widgetWrapper, 'v-chart': ECharts},
  render() {
    const {$theme, items} = this;
    const {title, subtitle, dateItem, unit, more, info, errorMessage} = items;
    const vChart = resolveComponent('v-chart');
    const legoIcon = resolveComponent('lego-icon');
    const cLabel = resolveComponent('c-label');
    const widgetWrapper = resolveComponent('widget-wrapper');

    const nullWidget = h('div', {class: ['widget-null']}, [
      h(legoIcon, {
        iconType: 'df',
        icon: 'exclamation_circle',
        size: 72,
        color: '#D6DCF4'
      }),
      h(
          cLabel,
          {
            size: 20,
            weight: 500
          },
          () => [errorMessage || this.t('label.noData')]
      )
    ]);
    const widgetChartPie =
        items.data.length > 0
            ? h(vChart, {
              autoresize: true,
              option: this.buildOption(),
              style: [{width: '100%', height: '100%'}]
            })
            : nullWidget;

    return h(
        widgetWrapper,
        {
          title,
          subtitle,
          dateItem,
          more,
          info,
          onMore: (more) => {
            this.$emit('more', more);
          }
        },
        () => [widgetChartPie]
    );
  },
  props: {
    items: {
      type: Object,
      default: () => {
      }
    }
  },
  methods: {
    localeString(val) {
      return val.toLocaleString();
    },
    buildOption() {
      const {$theme, items} = this;

      const series = items.data.map((seriesData, idx) => ({
        value: seriesData.value,
        name: seriesData.name,
        cursor: 'default',
        itemStyle: {color: $theme.COLOR.CHART[idx]}
      }));

      const option = {
        title: {
          subtext: this.items.unit
        },
        legend: {
          // formatter: function (name) {
          //   let itemValue = items.data.filter(item => item.name === name);
          //   return `{a|${name}}{b|${itemValue[0].value}}`;
          // },
          formatter: function (name) {
            let itemValue = items.data.filter((item) => item.name === name);
            return '{title|' + name + '}' + '{value|' + itemValue[0].value.toLocaleString() + '}';
          }
        },
        series: {
          data: series
        }
      };
      return _.merge({}, CHART.CHART_PIE, option);
    }
  }
};
</script>

<style scoped lang="scss">
.widget-chart-pie {
  height: 100%;
  margin: 0 auto;
  padding: 20px;
  position: relative;
}

.widget-null {
  text-align: center;
  display: flex;
  flex-direction: column;
  align-items: center;
  align-content: center;
  justify-content: center;
  height: 100%;

  :deep.lego-icon {
    margin-bottom: 17px;
  }
}
</style>
